<template>
  <app-content class="h-panel">
    <div class="flex justify-between m-16px pt-16px">
      <DropdownCustom ref="paramsDropdown" button class="h-btn-primary" trigger="click">
        <div v-if="params.start!==params.end">{{ fqFormat(params.start) }} 至 {{ fqFormat(params.end) }}</div>
        <div v-else>{{ fqFormat(params.start) }}</div>
        <template #content>
          <Form style="padding: 10px;width: 400px">
            <FormItem class="!pb-5px" label="会计期间">
              <div class="flex items-center">
                <Select @change="dateCheck" v-model="params.start" :deletable="false" filterable :datas="checkoutSelect"/>
                <span class="mx-8px">至</span>
                <Select @change="dateCheck" v-model="params.end" :deletable="false" filterable :datas="checkoutSelect"/>
              </div>
            </FormItem>
            <FormItem class="!pb-5px" label="会计科目">
              <Select :datas="subjectList" :filter="sfilter" keyName="id" titleName="fullName" @change="subjectSelect" v-model="subjectId">
                <template #show="{value}">
                  {{ value.code }} {{ value.fullName }}
                </template>
                <template #item="{item}">
                  {{ item.code }} {{ item.fullName }}
                </template>
              </Select>
            </FormItem>
            <FormItem class="!pb-5px" label="显示余额">
              <div><h-switch v-model="showBalance"></h-switch></div>
            </FormItem>
            <!-- 一中就够了jxd -->
            <!-- <FormItem class="!pb-5px" label="结束科目">
              <Radio v-model="params.showSubjectType" :datas="subjectType" ></Radio>
            </FormItem> -->
<!--            <FormItem class="!pb-5px" label="科目级别">
              <div class="flex items-center">
                <Select v-model="params.levelStart" :deletable="false" filterable :datas="[1,2,3,4]"/>
                <span class="mx-8px">至</span>
                <Select v-model="params.levelEnd" :deletable="false" filterable :datas="[1,2,3,4]"/>
              </div>
            </FormItem>-->
            <FormItem class="!pb-5px">
              <Button color="primary" @click="loadList();" :disabled="loading" :loading="loading">确定</Button>
              <Button @click="this.$refs.paramsDropdown.hide()">取消</Button>
              <Button @click="resetForm">重置</Button>
            </FormItem>
          </Form>
        </template>
      </DropdownCustom>
      <div class="float-right flex items-center">
<!--        <Checkbox class="mr-16px" :disabled="numPriceDisabled" v-model="showNumPrice">显示数量金额</Checkbox>-->
        <vxe-button @click="exportData" icon="fa fa-download" content="导出"/>
        <vxe-button @click="printData" icon="fa fa-print" content="打印"/>
      </div>
    </div>
    <div class="text-center mb-16px font-bold text-20px">{{ subject ? subject.name : "" }} {{ title }} 多栏账</div>
    <!-- jxd新版合并多栏账 -->
    <div class="h-panel-body flex ">
      <div style="overflow-x: auto;flex: 1;height: calc(100vh - 290px)" class="mr-8px">
        <vxe-table ref="xTable" :data="datalist" height="auto" border stripe>
          <vxe-column title="日期" field="voucherDate" width="110" align="center"/>
          <vxe-column title="凭证字号" field="voucherId" width="80" align="center">
            <template #default="{row}">
              <router-link class="text-hover primary-color" @success="loadList()" width="1120px"
                          v-if="row.voucherId"
                          :to="{name:'VoucherForm',params:{voucherId:row.voucherId}}">
                {{ row.word }}-{{ row.code }}
              </router-link>
            </template>
          </vxe-column>
          <!-- <vxe-column v-if="!showNumPrice" title="科1目" field="subjectName" width="180"/> -->
          <vxe-column title="摘要" field="summary" width="200"/>
          <vxe-column title="借方" field="debitAmount" width="130" align="right" formatter="toMoney"/>
          <vxe-column title="贷方" field="creditAmount" width="130" align="right" formatter="toMoney"/>
          <vxe-column title="方向" field="balanceDirection" align="center" width="70"/>
          <vxe-column title="余额" field="balance" width="130" align="right" formatter="toMoney"/>

          <!-- 新增部分，根据 this.children 条件展示 -->
          <template v-if="this.children && this.children.length > 0">
            <vxe-column v-for="child in children" :title="child.name + '(' + child.balanceDirection +')'" field="creditAmount" width="130" align="center" formatter="toMoney">
              <template #default="{row}">
                <div v-if="row.summary === '期初余额'">
                  {{ (findInitBalance(child.id,row)) }}
                </div>
                <div v-else-if="row.voucherId && child.code.startsWith(row.subjectCode)">
                  <!-- {{ row.balanceDirection === '贷' ? (row.creditAmount>0?row.creditAmount:-row.debitAmount).toFixed(2) : (row.debitAmount>0?row.debitAmount:-row.creditAmount).toFixed(2) }} -->
                  {{ findDayBanlance(child.id,row) }}
                </div>
                <div v-else-if="row.summary === '本期合计'">
                  {{ (findMonthBalance(child.id,row)) }}
                </div>
                <div v-else-if="row.summary === '本年累计'">
                  {{ (findYearBalance(child.id,row)) }}
                </div>
                <!-- duolan -->
                <div v-else-if="row.summary === '期末余额'">
                  {{ (findBanlance(child.id,row)) }}
                </div>
              </template>
            </vxe-column>
          </template>
        </vxe-table>
      </div>
    </div>
    <!-- 旧版分割多栏账 -->
    <!-- <div class="h-panel-body flex ">
      <div style="overflow-x: auto;flex: 1;height: calc(100vh - 290px)" class="mr-8px">
        <vxe-table ref="xTable" :data="datalist" height="auto" border stripe v-if="!showNumPrice">
          <vxe-column title="日期" field="voucherDate" width="110" align="center"/>
          <vxe-column title="凭证字号" field="voucherId" width="80" align="center">
            <template #default="{row}">
              <router-link class="text-hover primary-color" @success="loadList()" width="1024px"
                           v-if="row.voucherId"
                           :to="{name:'VoucherForm',params:{voucherId:row.voucherId}}">
                {{ row.word }}-{{ row.code }}
              </router-link>
            </template>
          </vxe-column>
          <vxe-column title="科1目" field="subjectName" width="180"/>
          <vxe-column title="摘要" field="summary" width="200"/>
          <vxe-column title="借方" field="debitAmount" width="130" align="right" formatter="toMoney"/>
          <vxe-column title="贷方" field="creditAmount" width="130" align="right" formatter="toMoney"/>
          <vxe-column title="方向" field="balanceDirection" align="center" width="70"/>
          <vxe-column title="余1额" field="balance" width="130" align="right" formatter="toMoney"/>
        </vxe-table>
        <vxe-table ref="xTable" :data="datalist" border stripe v-else>
          <vxe-column title="日期" field="voucherDate" width="110" align="center"/>
          <vxe-column title="凭证字号" field="voucherId" width="80" align="center">
            <template #default="{row}">
              <router-link class="text-hover primary-color" @success="loadList()" width="1024px"
                           v-if="row.voucherId"
                           :to="{name:'VoucherForm',params:{voucherId:row.voucherId}}">
                {{ row.word }}-{{ row.code }}
              </router-link>
            </template>
          </vxe-column>
        </vxe-table>
      </div>
      <div style="overflow-y: auto;max-height: calc(100vh - 290px)" v-if="this.children && this.children.length>0">
        <vxe-table ref="xTable" :data="datalist" height="auto" border stripe >
          <vxe-column v-for="child in children" :title="child.name + '(' + child.balanceDirection+')'" field="creditAmount" width="130" align="center" formatter="toMoney">
            <template #default="{row}">
              <div v-if="row.summary == '期初余额'">
                {{ (findInitBalance(child.id,row)) }}
              </div>
              <div v-else-if="row.voucherId && child.code.startsWith(row.subjectCode) ">
                {{ row.balanceDirection == '贷' ? (row.creditAmount>0?row.creditAmount:-row.debitAmount).toFixed(2) : (row.debitAmount>0?row.debitAmount:-row.creditAmount).toFixed(2) }}
              </div>
              <div v-else-if="row.summary == '本期合计'">
                {{ (findMonthBalance(child.id,row)) }}
              </div>
              <div v-else-if="row.summary == '本年累计'">
                {{ (findYearBalance(child.id,row)) }}
              </div>
            </template>
          </vxe-column>
        </vxe-table>
      </div>
    </div> -->
  </app-content>
</template>

<script>
import accountbook from "@/api/accountbook";
import {downloadBlob} from "download.js";
import manba from "manba";
import {mapGetters, mapState} from "vuex";
import BooUtil from "@/views/accountbook/bookUtil";
import AccountDateRangeChoose from "@/components/AccountDateRangeChoose";
import {clone, findTree, toArrayTree, toTreeArray} from "xe-utils";
import Qs from "qs";
import setting from "@/api/setting";

export default {
  name: 'DetailedAccounts',
  components: {AccountDateRangeChoose},
  data() {
    return {
      showBalance: true,//duolan
      loading: false,
      cloneParams: {},
      subjectList: [],
      // 一种就够了
      //subjectType:{ 1: '只展示下级科目', 2: '只展示明细科目' },
      params: {
        start: null,
        end: null,
        currencyId: null,
        levelStart: 1,
        levelEnd: 4,
        subjectStart: null,
        subjectEnd: null,
        showSubjectType: 2,
      },
      param: {
        keyName: 'id',
        parentName: 'parentId',
        titleName: 'name',
        dataMode: 'list',
        datas: []
      },
      datalist: [],
      children: [],
      generalLedger: [],
      subjectId: null,
      showNumPrice: false,
      numPriceDisabled: true,
      accountDate: null,
      subject: null,
      tablePrint: {
        // 自定义打印的样式示例
        style: `
          /* 整个表格的基础样式 */
          .vxe-table {
            font-family: "Microsoft YaHei", 微软雅黑, "MicrosoftJhengHei", 华文细黑, STHeiti, MingLiu; // 设置表格整体字体
          }

          /* 表头单元格 */
          .vxe-table thead th {
            border: 1px solid #000;
            font-size: 14px;
            word-break: break-all;
            overflow-wrap: break-word;
          }

          /* 表体单元格（即数据行的所有单元格） */
          .vxe-body--column, 
          .vxe-table tbody td {
            border: 1px solid #000;
            font-size: 12px;
            word-break: break-all;
            overflow-wrap: break-word;
          }
        `,
        beforePrintMethod: ({ content }) => {
          const headerHtml = `<h3>${this.subject.name} 多栏账</h3>
            <div style="display:flex;justify-content: space-between;height:22px;line-height:22px">
                <span>科目：${this.subject ? this.subject.name : ''}</span>
                <span> ${this.title} </span>
                <span> 单位：元 </span>
            </div>
          `;
          const footerHtml = `<div style="display:flex;justify-content: left;;height:22px;line-height:22px">编制单位：${this.currentAccountSets.companyName}</div>`;
          return `${headerHtml}${content}${footerHtml}`;
        },
      },
    };
  },
  computed: {
    ...mapState(['currentAccountSets']),
    ...mapGetters(['checkoutSelect', 'localCurrency']),
    title() {
      if (!this.params.start) {
        return '';
      }
      if (this.params.start === this.params.end) {
        return manba(this.params.start).format("YYYY年MM期")
      }
      return manba(this.params.start).format("YYYY年MM期") + " - " + manba(this.params.end).format("YYYY年MM期");
    }
  },
  watch: {
    subject() {
      let org = this.showNumPrice;
      if (this.subject.unit) {
        this.numPriceDisabled = false;
        this.showNumPrice = false;
      } else {
        this.showNumPrice = false;
      }
      this.loadList();
    },
    showNumPrice() {
      this.loadList();
    }
  },
  methods: {
    dateCheck(){
      // 定义开始时间和结束时间
      let startDate = new Date(this.params.start);
      let endDate = new Date(this.params.end);
      if(startDate > endDate){
        this.$Message({
          type:'warn',
          text: `开始时间必须早于或等于结束时间！`
        });
      }
    },
    //加载科目
    loadSubject() {
      this.datalist = [];
      accountbook.loadSubject(this.params).then(({data}) => {
        this.param.datas = data;
        if (data.length) {
          this.subjectId = data[0].id;
          this.subject = data[0];
        } else {
          this.datalist = [];
        }
      });
    },
    sfilter(item, val) {
      return item.code.indexOf(val) !== -1 || item.name.indexOf(val) !== -1 || item.mnemonicCode.indexOf(val) !== -1;
    },
    loadList() {
      if (this.subjectId) {
        this.loading = true;
        accountbook.loadVoucherMultiDetails(Object.assign({
          subjectId: this.subjectId,
          showNumPrice: this.showNumPrice,
          subjectCode: this.subject.code,
          showSubjectType: "1"
        }, this.params)).then(({data}) => {
          //下面判断是否显示余额 duolan
          if(this.showBalance){
            let newData = [];
            data.details.forEach((item, index) => {
                // 将当前项添加到新数组中
                newData.push(item);
                // 检查是否是"本年累计"
                if (item.summary === "本年累计") {
                    // 创建新的"期末余额"对象
                    // 注意：这里假设余额是基于现有数据计算的，比如最后一个项目的balance值
                    // 根据实际情况调整此部分
                    let endBalanceItem = {
                        voucherDate:item.voucherDate,
                        balanceDirection: item.balanceDirection,
                        summary: "期末余额",
                        balance: item.balance, // 或者根据实际逻辑计算得到
                    };
                    // 在"本年累计"之后插入"期末余额"对象
                    newData.push(endBalanceItem);
                }
            });
            data.details = newData;
          }
          //up面判断是否显示余额
          this.datalist = data.details;
          this.children = data.children;
          console.log(data)
          console.log(JSON.stringify(this.children))
          //jxd多栏账范围查询
          //通过总账查询子科目的期初，如果数组>=2，代表范围查询，>0代表就一个子科目
          if(this.children.length >= 2){
            this.loadListGeneralLedger(this.params.start,this.children[0].code,this.children[this.children.length - 1].code);
          }else if(this.children.length > 0){
            this.loadListGeneralLedger(this.params.start,this.children[0].code,this.children[0].code);
          }
          //通过总账查询子科目的本期合计，本年累计
          if(this.children.length >= 2){
            this.loadListGeneralLedger2(this.params.start,this.children[0].code,this.children[this.children.length - 1].code,this.params.end);
          }else if(this.children.length > 0){
            this.loadListGeneralLedger2(this.params.start,this.children[0].code,this.children[0].code,this.params.end);
          }
          this.$refs.paramsDropdown.hide()
        }).finally(() => this.loading = false);
      }
    },
    //查询总账
    loadListGeneralLedger2(month,subjectStart,subjectEnd,month2) {
      // console.log(subjectStart,subjectEnd)
      let monthYear = month.substring(0, 7);
      let monthYear2 = month2.substring(0, 7);
      let params = {
				start: monthYear,
				end: monthYear2,
				levelStart: 1,
				levelEnd: 4,
				currencyId: this.localCurrency.id,
				// subjectStart: subjectStart,
				// subjectEnd: subjectEnd,
			}
			accountbook.loadGeneralLedger(Object.assign({}, params, {
				showNumPrice: false
			})).then(({data}) => {
				this.generalLedger = data;
        console.log(data)
			})
		},
    //查询总账
    loadListGeneralLedger(month,subjectStart,subjectEnd) {
      // console.log(subjectStart,subjectEnd)
      let monthYear = month.substring(0, 7);
      let params = {
				start: monthYear,
				end: monthYear,
				levelStart: 1,
				levelEnd: 4,
				currencyId: this.localCurrency.id,
				// subjectStart: subjectStart,
				// subjectEnd: subjectEnd,
			}
			accountbook.loadGeneralLedger(Object.assign({}, params, {
				showNumPrice: false
			})).then(({data}) => {
				// console.log(data);
        this.children.forEach((item) => {
          // console.log(item)
          data.forEach((items) => {
            if (item.id === items.subjectId) {
              item.balance = items.dataRows[0].balance
            }                                                                   
          })
        })
        //没有期初的期初设置0
        this.children.forEach((item) => {
          if(!item.balance){
            item.balance = 0
          }
        })
        //过滤掉无期初，无发生额的子科目
        this.dataFilter();
        // console.log(this.children)
			})
		},
    //过滤数据
    dataFilter(){
      //如果有子科目
      if(this.children.length > 0){
        // console.log(this.datalist,this.children)
        //提取明细中涉及到的子科目，也就是有明细数据的子科目
        let uniqueSubjectCodes = [...new Set(this.datalist.filter(item => item.voucherId).map(item => item.subjectCode))];
        // console.log(uniqueSubjectCodes)
        //然后如果子科目没有明细，也没有期初，则从children中删除他
        // this.children.forEach((item, index) => {
        //   console.log(!uniqueSubjectCodes.includes(item.code),item.balance,item.code)
        //   if (!uniqueSubjectCodes.includes(item.code) && item.balance === 0) {
        //     this.children.splice(index, 1);
        //   }
        // });
        for(let i = 0;i<this.children.length;i++){
          if (!uniqueSubjectCodes.includes(this.children[i].code) && this.children[i].balance === 0) {
            this.children.splice(i, 1);
            i--;
          }
        }
        // console.log(this.children)
      }
    },
    //查询期末余额 duolan
    findBanlance(id,row){
      let find = this.children.find(item => item.id === id); 
      let num = 0;
      this.generalLedger.forEach((item) => {
        if(item.subjectId === id){
          item.dataRows.forEach((items) => {
            const formattedDateString = `${row.voucherDate.split('-')[0]}年${row.voucherDate.split('-')[1]}月`;
            if(items.date == formattedDateString && items.summary == '本年累计'){
              //这里也改成子科目自己的方向
              // num = row.balanceDirection == '借' ? items.debit - items.credit : items.credit - items.debit ;
              num = items.balance;
            }
          })
        }
      })
      return num ? num.toFixed(2) : '';
    },
    //查询期初
    findInitBalance(id,row){
      // console.log(id,row,this.children)
      let res;
      this.children.forEach((item) => {
        if (item.id === id) {
          res = item.balance;
        }
      })
      return res ? res.toFixed(2) : '';
    },
    //查询本期合计
    findMonthBalance(id,row) {
      let find = this.children.find(item => item.id === id); 
      let num = 0;
      this.generalLedger.forEach((item) => {
        if(item.subjectId === id){
          item.dataRows.forEach((items) => {
            const formattedDateString = `${row.voucherDate.split('-')[0]}年${row.voucherDate.split('-')[1]}月`;
            if(items.date == formattedDateString && items.summary == '本期合计'){
              //这里也改成子科目自己的方向
              // num = row.balanceDirection == '借' ? items.debit - items.credit : items.credit - items.debit ;
              num = find.balanceDirection == '借' ? items.debit - items.credit : items.credit - items.debit ;
            }
          })
        }
      })
      return num ? num.toFixed(2) : '';
    },
    //查询本年累计
    findYearBalance(id,row){
      let find = this.children.find(item => item.id === id); 
      let num = 0;
      this.generalLedger.forEach((item) => {
        if(item.subjectId === id){
          item.dataRows.forEach((items) => {
            const formattedDateString = `${row.voucherDate.split('-')[0]}年${row.voucherDate.split('-')[1]}月`;
            if(items.date == formattedDateString && items.summary == '本年累计'){
              //原来用父科目的方向判断，如果子科目方向不一致会错误
              // num = row.balanceDirection == '借' ? items.debit - items.credit : items.credit - items.debit ;
              num = find.balanceDirection == '借' ? items.debit - items.credit : items.credit - items.debit ;
            }
          })
        }
      })
      return num ? num.toFixed(2) : '';
    },
    
    //查询当日每行数据的值
    findDayBanlance(id,row){
      let find = this.children.find(item => item.id === id); 
      let num = 0;
      num = find.balanceDirection == '贷' ? (row.creditAmount ? row.creditAmount:-row.debitAmount).toFixed(2) : (row.debitAmount ? row.debitAmount:-row.creditAmount).toFixed(2);
      return num ? num : '';
    },
    subjectSelect(node) {
      this.subject = node;
      // console.log(node)
    },
    exportData() {
      if (this.param.datas.length) {
        const utils = new BooUtil(this.$refs.xTable, '\n')
        accountbook.download({header: utils.header, dataList: utils.dataList}).then((data) => {
          downloadBlob(`${this.subject.name}-${this.title}-明细账.xls`, data)
        })
      }
    },
    printData() {
      // 获取VXE-Table实例
      const xTable = this.$refs.xTable;
      // 调用打印方法，并传入打印配置
      xTable.print({
        ...this.tablePrint,
      });
    },
    resetForm() {
      this.params = clone(this.cloneParams, true)
    }
  },
  created() {
    this.params.start = manba(this.currentAccountSets.currentAccountDate).format("YYYY-M");
    this.params.end = this.params.start;
    this.params.currencyId = this.localCurrency.id;
    this.cloneParams = clone(this.params, true)
    this.loadSubject();

    setting.subject.listAll().then(({data}) => {
      this.subjectList = data;
    })
  }
};
</script>
